import HeartbeatComponent from './heartbeat.component';
import { heartbeatReducer } from './heartbeat.reducer';

export {
  HeartbeatComponent,
  heartbeatReducer,
}



// WEBPACK FOOTER //
// src/auth/heartbeat-system/index.js